import { render, staticRenderFns } from "./Siting.vue?vue&type=template&id=50cf83f7&scoped=true"
import script from "./Siting.vue?vue&type=script&lang=js"
export * from "./Siting.vue?vue&type=script&lang=js"
import style0 from "./Siting.vue?vue&type=style&index=0&id=50cf83f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf83f7",
  null
  
)

export default component.exports